/**
 * FIZITI Scroll Animations
 * Elegant enter animations triggered by IntersectionObserver
 * Respects prefers-reduced-motion
 */

(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ── Animation targets ─────────────────────────────────────── */
  const SELECTORS = [
    { sel: '.section-header',        anim: 'fade-up', delay: 0 },
    { sel: '.section-title',         anim: 'fade-up', delay: 0 },
    { sel: '.product-card',          anim: 'fade-up', stagger: 0.08 },
    { sel: '.trust-bar__item',       anim: 'fade-up', stagger: 0.07 },
    { sel: '.feature-card',          anim: 'fade-up', stagger: 0.1 },
    { sel: '.size-card',             anim: 'fade-up', stagger: 0.1 },
    { sel: '.review-card',           anim: 'fade-up', stagger: 0.1 },
    { sel: '.qd-row',                anim: 'fade-up', delay: 0 },
    { sel: '.qd-stat',               anim: 'fade-up', stagger: 0.06 },
    { sel: '.gallery-item',          anim: 'scale-in', stagger: 0.05 },
    { sel: '.brand-story__image',    anim: 'fade-right', delay: 0 },
    { sel: '.brand-story__content',  anim: 'fade-left', delay: 0.1 },
    { sel: '.hero-banner__content',  anim: 'fade-up', delay: 0 },
    { sel: '.pdp-gallery',           anim: 'fade-right', delay: 0 },
    { sel: '.pdp-info',              anim: 'fade-left', delay: 0.08 },
  ];

  /* ── Inject CSS ────────────────────────────────────────────── */
  const style = document.createElement('style');
  style.textContent = `
    [data-fiziti-animate] {
      transition-property: opacity, transform;
      transition-timing-function: cubic-bezier(0.22, 1, 0.36, 1);
      transition-duration: 0.65s;
      will-change: opacity, transform;
    }

    [data-fiziti-animate="fade-up"]    { opacity: 0; transform: translateY(28px); }
    [data-fiziti-animate="fade-down"]  { opacity: 0; transform: translateY(-28px); }
    [data-fiziti-animate="fade-right"] { opacity: 0; transform: translateX(-32px); }
    [data-fiziti-animate="fade-left"]  { opacity: 0; transform: translateX(32px); }
    [data-fiziti-animate="scale-in"]   { opacity: 0; transform: scale(0.94); }
    [data-fiziti-animate="fade-in"]    { opacity: 0; transform: none; }

    [data-fiziti-animate].fiziti-visible {
      opacity: 1 !important;
      transform: none !important;
    }
  `;
  document.head.appendChild(style);

  /* ── Tag elements ──────────────────────────────────────────── */
  function tagElements() {
    SELECTORS.forEach(({ sel, anim, delay = 0, stagger }) => {
      const els = document.querySelectorAll(sel);
      els.forEach((el, i) => {
        if (el.hasAttribute('data-fiziti-animate')) return;
        el.setAttribute('data-fiziti-animate', anim);
        const d = stagger != null ? i * stagger + delay : delay;
        if (d > 0) el.style.transitionDelay = d + 's';
      });
    });
  }

  /* ── Observe ───────────────────────────────────────────────── */
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fiziti-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: '0px 0px -40px 0px',
    threshold: 0.08
  });

  function observeAll() {
    document.querySelectorAll('[data-fiziti-animate]').forEach(el => observer.observe(el));
  }

  /* ── Init ──────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { tagElements(); observeAll(); });
  } else {
    tagElements();
    observeAll();
  }

  // Re-tag after dynamic content updates (e.g. cart drawer renders)
  window.FizitiAnimate = {
    refresh: () => { tagElements(); observeAll(); }
  };
})();
